import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { PortableTextBlock } from '@portabletext/react'
import { CmsSectionText } from './cms-section-text-content'

interface LayoutProps {
  imagePosition: 'left' | 'right'
  cardText: PortableTextBlock[]
  image: string
  dataTestId?: string
  imageAltText?: string
  layoutContainerClasses?: string
}

const CMSCardTextImageLayout = ({
  image,
  imagePosition,
  imageAltText,
  cardText,
  dataTestId,
  layoutContainerClasses = 'mt-24px',
}: LayoutProps) => {
  return (
    <div
      className={`${layoutContainerClasses} flex gap-10px ${
        imagePosition === 'left' ? 'flex-row-reverse' : ''
      }`}
      data-testid={dataTestId}
    >
      {cardText?.length && (
        <CmsSectionText className='card flex-1'>
          <RichTextRenderer content={cardText} variant='opportunity-details' />
        </CmsSectionText>
      )}
      {image && (
        <div className='card card-image'>
          <img src={image} alt={imageAltText} className='width-100percent height-100percent' />
        </div>
      )}
    </div>
  )
}

export { CMSCardTextImageLayout }
